import { OptionRenderType, QuestionType } from '@/manager-graphql';
import {
  OPTION_RENDER_TYPES,
  QUESTION_SHAPES,
  type OptionRenderType as QuestionKindOptionRenderType,
  type QuestionKindInput,
  type QuestionShape,
} from '@/shared-question-model';

export interface QuestionKindSource {
  type: QuestionType;
  optionRenderType?: OptionRenderType | null;
  subQuestionsCount?: number;
  isContactInfo?: boolean;
  isUrl?: boolean;
  isMobileApp?: boolean;
}

function toQuestionShape(
  type: QuestionType,
  isUrl: boolean | undefined,
  isMobileApp: boolean | undefined
): QuestionShape {
  switch (type) {
    case QuestionType.Message:
      if (isMobileApp) return QUESTION_SHAPES.MobileApp;
      return isUrl ? QUESTION_SHAPES.Url : QUESTION_SHAPES.Message;
    case QuestionType.MultipleChoice:
      return QUESTION_SHAPES.MultipleChoice;
    case QuestionType.OpenEnded:
      return QUESTION_SHAPES.OpenEnded;
    case QuestionType.Ranking:
      return QUESTION_SHAPES.Ranking;
    case QuestionType.Rating:
      return QUESTION_SHAPES.Rating;
    case QuestionType.Task:
      return QUESTION_SHAPES.Task;
    default: {
      const unexpected: never = type;
      throw new Error('Unexpected question type: ' + String(unexpected));
    }
  }
}

function toOptionRenderType(
  optionRenderType: OptionRenderType | null | undefined
): QuestionKindOptionRenderType | null {
  if (optionRenderType == null) return null;

  switch (optionRenderType) {
    case OptionRenderType.Media:
      return OPTION_RENDER_TYPES.Media;
    case OptionRenderType.Emoji:
    case OptionRenderType.Star:
    case OptionRenderType.Text:
      return OPTION_RENDER_TYPES.Text;
    default: {
      const unexpected: never = optionRenderType;
      throw new Error('Unexpected option render type: ' + String(unexpected));
    }
  }
}

export function toQuestionKindInput({
  type,
  optionRenderType,
  subQuestionsCount,
  isContactInfo,
  isUrl,
  isMobileApp,
}: QuestionKindSource): QuestionKindInput {
  return {
    questionShape: toQuestionShape(type, isUrl, isMobileApp),
    optionRenderType: toOptionRenderType(optionRenderType),
    subQuestionCount: subQuestionsCount ?? 0,
    isContactInfo: !!isContactInfo,
  };
}
